import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20elegant%20abstract%20background%20with%20soft%20gradients%20of%20coral%20and%20gold%20tones%2C%20subtle%20geometric%20patterns%2C%20luxurious%20minimalist%20design%2C%20gift%20box%20silhouettes%20in%20the%20distance%2C%20soft%20ambient%20lighting%2C%20premium%20lifestyle%20aesthetic%2C%20clean%20and%20modern%20composition&width=1800&height=900&seq=hero-fuli-2024&orientation=landscape"
          alt="福利导航 Hero 背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full text-center px-4 md:px-6 max-w-4xl mx-auto">
        <h1 className="text-3xl md:text-5xl font-heading text-white mb-4 md:mb-6 leading-tight">
          发现好福利，从这里开始
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed mb-8">
          福利导航为您汇聚全网优质福利资源，涵盖电商优惠、会员权益、生活补贴、职场福利等多类目，帮助您快速找到最划算的福利入口，省时省钱不踩坑。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/ecommerce"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            开始探索福利
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white text-sm font-medium hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer border border-white/20"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}